import React, { useState, useMemo } from "react";
import StudentListItem from "./StudentListItem";

const NAV_ITEMS = [
	{ key: "dashboard", label: "Dashboard", icon: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" },
	{ key: "weekly", label: "Rapport hebdo", icon: "M9 11H7v6h2v-6zm4 0h-2v6h2v-6zm4 0h-2v6h2v-6zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z" },
	{ key: "templates", label: "Templates", icon: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 7h10v2H7zm0 4h10v2H7zm0 4h7v2H7z" },
];

export default function CoachSidebar({
	view,
	onSelectView,
	students,
	selectedStudent,
	user,
	studentScores,
	onSelectStudent,
	onStudentMessage,
	onStudentNote,
	onStudentPlan,
}) {
	const [filter, setFilter] = useState("");

	const scoresMap = useMemo(() => {
		const m = {};
		(studentScores || []).forEach((s) => {
			m[s.id] = s;
		});
		return m;
	}, [studentScores]);

	const allStudents = useMemo(() => {
		const list = [];
		if (user && user.id) {
			list.push({ id: user.id, prenom: user.prenom, nom: user.nom, photoProfil: user.photoProfil, isSelf: true });
		}
		(students || []).forEach((s) => list.push(s));
		return list;
	}, [students, user]);

	const filteredStudents = useMemo(() => {
		if (!filter.trim()) return allStudents;
		const q = filter.trim().toLowerCase();
		return allStudents.filter((s) =>
			(`${s.prenom || ""} ${s.nom || ""}`).toLowerCase().includes(q)
		);
	}, [allStudents, filter]);

	return (
		<aside className="coach-sidebar">
			<nav className="coach-sidebar-nav">
				{NAV_ITEMS.map((item) => (
					<button
						key={item.key}
						className={`coach-sidebar-nav-item ${view === item.key ? "active" : ""}`}
						onClick={() => onSelectView(item.key)}
					>
						<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
							<path d={item.icon} />
						</svg>
						<span>{item.label}</span>
					</button>
				))}
			</nav>

			<div className="coach-sidebar-divider" />

			<div className="coach-sidebar-section-header">
				<span className="coach-sidebar-section-title">
					Élèves <span className="coach-sidebar-count">{allStudents.length}</span>
				</span>
			</div>

			<div className="coach-sidebar-filter">
				<input
					type="text"
					value={filter}
					onChange={(e) => setFilter(e.target.value)}
					placeholder="Filtrer…"
					className="coach-sidebar-filter-input"
				/>
			</div>

			<div className="coach-sidebar-students">
				{filteredStudents.length === 0 && (
					<div className="coach-sidebar-empty">Aucun élève</div>
				)}
				{filteredStudents.map((s) => (
					<StudentListItem
						key={s.id}
						student={s}
						score={scoresMap[s.id]}
						isActive={view === "student" && selectedStudent?.id === s.id}
						onClick={() => onSelectStudent(s)}
						onMessage={onStudentMessage}
						onNote={onStudentNote}
						onPlan={onStudentPlan}
					/>
				))}
			</div>
		</aside>
	);
}
